// O'ng tugma menyulari, uz
export default {
  open: "Ochish",
  openNewTab: "Yangi tabda ochish",
  copyLink: "Havolani nusxalash",
  copyPhone: "Telefonni nusxalash",
  copyEmail: "Emailni nusxalash",
  copyUsername: "Loginni nusxalash",
  openProfile: "Profilni ochish",
  openPersonProfile: "Profilni ochish: {{name}}",
  openDriver: "Driverni ochish: {{name}}",
  copyName: "Ismni nusxalash",
  call: "Qo'ng'iroq qilish",
  sendEmail: "Email yozish",
  copied: "Nusxalandi",
  copyFailed: "Nusxalab bo'lmadi",
  edit: "Tahrirlash",
  archive: "Arxivlash",
  setStatus: "Statusni belgilash",
  archiveTitle: "{{name}} arxivlansinmi?",
  archivedToast: "{{name}} arxivlandi",
  statusChanged: "{{name}} → {{status}}",
  conflict: "Boshqa birov hozirgina bu yozuvni o'zgartirdi. Ro'yxat yangilandi, qayta urinib ko'ring.",
  failed: "Amal bajarilmadi",
  placement: {
    addPayment: "To'lovni yozish…",
    edit: "To'lov shartlari…",
    writeOff: "To'lanmadi deb belgilash",
    reopen: "Qayta ochish",
    payments: "Tushumlar",
    voidPayment: "To'lovni bekor qilish",
    awaitingApproval: "Hire tasdig'i kutilmoqda",
  },
  driver: {
    logCall: "Qo'ng'iroqni yozish",
    addNote: "Izoh qo'shish",
    addReminder: "Eslatma qo'shish",
    documents: "Hujjatlar",
    changeStatus: "Statusni o'zgartirish",
    moveTo: "Ko'chirish",
    markLost: "Yo'qotilgan deb belgilash…",
    transfer: "Boshqa recruiterga o'tkazish…",
    openJob: "Vakansiyani ochish: {{title}}",
    openCarrier: "Carrier'ni ochish: {{name}}",
    archiveTitle: "{{name}} arxivlansinmi?",
    archiveDesc: "Driver ro'yxatlar, jarayon va hisobotlardan yo'qoladi. Tarixi audit jurnalida qoladi.",
    archived: "{{name}} arxivlandi",
  },
  activity: {
    title: "Faollikni yozish · {{name}}",
    type: "Turi",
    types: { call: "Qo'ng'iroq", note: "Izoh", sms: "SMS", email: "Email" },
    outcome: "Natija",
    minutes: "Daqiqa",
    body: "Izoh",
    placeholderCall: "Nima haqida gaplashdingiz?",
    placeholderNote: "Izoh yozing…",
    bodyRequired: "Izoh uchun matn yozing.",
    saved: "Driver faolligiga yozildi",
  },
  transfer: {
    title: "{{name}}ni o'tkazish",
    to: "Yangi egasi",
    pool: "Filial pooli (egasiz)",
    note: "Yangi egasi uchun izoh",
    current: "Hozirgi egasi: {{name}}",
    nobody: "yo'q",
    submit: "O'tkazish",
    done: "{{name}} → {{to}}",
    chooseUser: "Driver kimga o'tishini tanlang.",
  },
  task: {
    markDone: "Bajarildi deb belgilash",
    snooze: "Keyinga surish",
    reopen: "Qayta ochish",
    addFollowUp: "Keyingi eslatmani qo'shish",
    copyNote: "Izohni nusxalash",
  },
  approval: {
    approve: "Tasdiqlash…",
    reject: "Rad etish…",
    openBudget: "Budjetda ochish",
    copySummary: "Tavsifni nusxalash",
  },
  notification: {
    markRead: "O'qildi deb belgilash",
    markUnread: "O'qilmagan deb belgilash",
    markAllRead: "Hammasini o'qildi deb belgilash",
    copyText: "Matnni nusxalash",
  },
  truck: {
    openDriver: "Driverni ochish: {{name}}",
    copyVin: "VIN'ni nusxalash",
    copyPlate: "Raqamni nusxalash",
  },
  carrier: {
    copyMc: "MC raqamini nusxalash ({{mc}})",
    showJobs_one: "Vakansiyalarni ko'rish ({{count}} ta ochiq)",
    showJobs_other: "Vakansiyalarni ko'rish ({{count}} ta ochiq)",
    newJob: "Shu carrier uchun yangi vakansiya…",
    archiveDesc: "Carrier va uning vakansiyalari ro'yxatlardan yo'qoladi. Yuborilgan driverlar va tarix saqlanadi.",
  },
  job: {
    submitDriver: "Driver yuborish…",
    openCarrier: "Carrier'ni ochish: {{name}}",
    archiveDesc: "Vakansiya ro'yxatlardan yo'qoladi va unga driver yuborib bo'lmaydi. Arizalar driver tarixida qoladi.",
  },
  user: {
    showDrivers_one: "{{count}} ta driverni ko'rish",
    showDrivers_other: "{{count}} ta driverni ko'rish",
    setPassword: "Yangi parol berish…",
    reset2fa: "2FA'ni tiklash",
    reset2faTitle: "{{name}} uchun 2FA tiklansinmi?",
    reset2faDesc: "Uning hozirgi autentifikatori ishlamay qoladi. Roli uchun 2FA majburiy bo'lsa, keyingi kirishda qayta sozlaydi.",
    block: "Bloklash…",
    unblock: "Blokdan chiqarish",
    access: "Ruxsatlar…",
  },
  branch: {
    openDashboard: "Filial dashboard'ini ochish",
    openBudget: "Filial budjetini ochish",
    showUsers_one: "Xodimlarni ko'rish ({{count}} ta recruiter)",
    showUsers_other: "Xodimlarni ko'rish ({{count}} ta recruiter)",
    openReport: "Filial hisobotini ochish",
    people: "Xodimlarni ko'rish",
  },
  budget: {
    reviewInApprovals: "Tasdiqlashlarda ko'rib chiqish",
    openReceipt: "Chekni ochish",
    payExpense: "Hisobdan to'lash",
    copyAmount: "Summani nusxalash",
    copyDescription: "Tavsifni nusxalash",
    markPaid: "To'landi deb belgilash",
    markUnpaid: "To'lanmagan deb qaytarish",
    showDetails: "Tafsilotlarni ko'rsatish",
    hideDetails: "Tafsilotlarni yashirish",
    adjust: "Tuzatish…",
    approveBonus: "Shu bonusni tasdiqlash",
  },
  audit: {
    showDetails: "Tafsilotlarni ko'rsatish",
    openObject: "Ochish: {{name}}",
    filterActor: "Faqat {{name}} amallari",
    filterModel: "Faqat shu turdagi obyektlar",
    copyDetails: "Tafsilotlarni nusxalash (JSON)",
    copyRequestId: "Request ID'ni nusxalash",
  },
  import: {
    continue: "Importni davom ettirish",
    openResult: "Natijani ochish",
    openSheet: "Jadvalni Google'da ochish",
    copySheetLink: "Jadval havolasini nusxalash",
  },
  recruiter: {
    showDrivers: "{{name}} driverlarini ko'rish",
    openReport: "Hisobotlarda ochish",
    focus: "Faqat {{name}}ni ko'rsatish",
  },
  report: {
    sourceDrivers: "{{source}} driverlarini ko'rish",
    carrierJobs: "Carrier vakansiyalarini ko'rish",
  },
  portal: {
    details: "Tafsilotlarni ochish",
    accept: "Qabul qilish…",
    reject: "Rad etish…",
    copyTitle: "Vakansiya nomini nusxalash",
    copyPay: "Maoshni nusxalash",
  },
  application: {
    copyReply: "Carrier javobini nusxalash",
  },
  activityItem: {
    copyText: "Matnni nusxalash",
  },
};
